import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_PROJECT_WISE_TICKETS, SUPERSET_PROJECT_WISE_TICKETS_ERROR, SUPERSET_PROJECT_WISE_TICKETS_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetProjectWiseTickets({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_PROJECT_WISE_TICKETS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_PROJECT_WISE_TICKETS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_PROJECT_WISE_TICKETS_ERROR, payload: error });
  }
}

export function* watchSupersetProjectWiseTickets() {
  yield takeEvery(SUPERSET_PROJECT_WISE_TICKETS, supersetProjectWiseTickets);
}

function* supersetProjectWiseTicketsSaga() {
  yield all([fork(watchSupersetProjectWiseTickets)]);
}

export default supersetProjectWiseTicketsSaga;
